import { get_token } from '@/router/index.js';
import OneChatWebSocketClient from '@/services/one_chat_websocket';

export const navbar_chat_notification_methods = {
  init_chat_socket() {
    const token = get_token();
    if (!token) return;

    this.reset_chat_socket();
    this.chat_socket = this.create_chat_socket(token);
    this.chat_socket.connect();
  },

  reset_chat_socket() {
    this.chat_socket?.disconnect?.();
  },

  create_chat_socket(token) {
    return new OneChatWebSocketClient({
      token,
      on_open: () => this.handle_chat_socket_open(),
      on_close: () => this.handle_chat_socket_close(),
      on_error: event => this.handle_chat_socket_error(event),
      on_event: event => this.handle_chat_socket_event(event),
    });
  },

  handle_chat_socket_open() {
    this.chat_socket_connected = true;
    this.chat_socket_last_error = null;
    this.fetch_unread_chat_count();
  },

  handle_chat_socket_close() {
    this.chat_socket_connected = false;
  },

  handle_chat_socket_error(event) {
    this.chat_socket_last_error = event;
    console.error('ONE Chat navbar websocket error', event);
  },

  handle_chat_socket_event(event) {
    if (event?.type !== 'unread.total.updated') return;
    this.apply_unread_chat_count(event.unread_count);
  },

  async fetch_unread_chat_count() {
    if (!this.chat_socket?.is_open()) return;

    try {
      const response = await this.chat_socket.request('unread.total');
      this.apply_unread_chat_count(response?.data?.unread_count);
    } catch (error) {
      console.error('Error fetching chat count over websocket:', error);
    }
  },

  should_notify_unread_chat_increase(new_count) {
    return this._chat_count_initialized && new_count > this.unread_chat_count;
  },

  get_unread_chat_message(diff) {
    return diff === 1 ? 'You have a new message' : `You have ${diff} new messages`;
  },

  notify_unread_chat_increase(new_count) {
    const diff = new_count - this.unread_chat_count;

    this.fire_browser_notification(
      'New Message - ONE Chat',
      this.get_unread_chat_message(diff),
      {
        tag: 'aic-chat-message',
        on_click: () => this.$router.push('/chat'),
      }
    );
  },

  apply_unread_chat_count(raw_count) {
    const new_count = Number(raw_count ?? 0);

    if (this.should_notify_unread_chat_increase(new_count)) {
      this.notify_unread_chat_increase(new_count);
    }

    this._chat_count_initialized = true;
    this.unread_chat_count = new_count;
    window.__one_chat_unread_count = new_count;
    window.dispatchEvent(new CustomEvent('one-chat-unread-count', {
      detail: { unread_count: new_count },
    }));
  },
};
